'use client';
import { createQuery, Refresh } from '@s7/query';
import { compileTemplate } from '../../../common/compileTemplate/compileTemplate.js';

var useSearchQuery = createQuery(function(param) {
    var url = param.url, query = param.query;
    return {
        query: compileTemplate(url, {
            limit: 10,
            lang: "ru",
            query: query
        }),
        refresh: Refresh.Never
    };
});

export { useSearchQuery };
